/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
// Generated by build-products.mjs – DO NOT EDIT BY HAND.
//
// Kept separate from products.tsx on purpose: this map's dynamic imports reach every
// product scene, and products.tsx is imported app-wide via scenes/urls.ts. In one module,
// jest's --findRelatedTests would mark ~the whole test suite as related to any scene change.
// Import this only from scene-mounting code (scenes/appScenes.ts).

/** This const is auto-generated, as is the whole file */
export const productScenes: Record<string, () => Promise<any>> = {
  Actions: () => import("../../products/actions/frontend/pages/Actions"),
  Action: () => import("../../products/actions/frontend/pages/Action"),
  NewAction: () => import("../../products/actions/frontend/pages/Action"),
  AIGateway: () => import("../../products/ai_gateway/frontend/AIGatewayScene"),
  AIObservability: () => import("../../products/ai_observability/frontend/AIObservabilityScene"),
  AIObservabilityTrace: () =>
    import("../../products/ai_observability/frontend/AIObservabilityTraceScene"),
  AIObservabilitySession: () =>
    import("../../products/ai_observability/frontend/AIObservabilitySessionScene"),
  AIObservabilityUsers: () =>
    import("../../products/ai_observability/frontend/AIObservabilityUsers"),
  AIObservabilityPlayground: () =>
    import("../../products/ai_observability/frontend/playground/AIObservabilityPlaygroundScene"),
  AIObservabilityDatasets: () =>
    import("../../products/ai_observability/frontend/datasets/AIObservabilityDatasetsScene"),
  AIObservabilityDataset: () =>
    import("../../products/ai_observability/frontend/datasets/AIObservabilityDatasetScene"),
  AIObservabilityEvaluations: () =>
    import("../../products/ai_observability/frontend/evaluations/EvaluationsScene"),
  AIObservabilityScorers: () =>
    import("../../products/ai_observability/frontend/scoreDefinitions/AIObservabilityScorersScene"),
  AIObservabilityScorer: () =>
    import("../../products/ai_observability/frontend/scoreDefinitions/AIObservabilityScorerScene"),
  AIObservabilityOfflineExperiments: () =>
    import("../../products/ai_observability/frontend/offline-evaluations/OfflineExperimentsScene"),
  AIObservabilityOfflineExperiment: () =>
    import("../../products/ai_observability/frontend/offline-evaluations/OfflineExperimentScene"),
  AIObservabilityOfflineScorerHistory: () =>
    import("../../products/ai_observability/frontend/offline-evaluations/OfflineScorerHistoryScene"),
  AIObservabilityEvaluation: () =>
    import("../../products/ai_observability/frontend/evaluations/AIObservabilityEvaluation"),
  AIObservabilityEvaluationTemplates: () =>
    import("../../products/ai_observability/frontend/evaluations/EvaluationTemplates"),
  AIObservabilityTags: () =>
    import("../../products/ai_observability/frontend/tags/AIObservabilityTagsScene"),
  AIObservabilityTag: () =>
    import("../../products/ai_observability/frontend/tags/AIObservabilityTagScene"),
  AIObservabilityPrompts: () =>
    import("../../products/ai_observability/frontend/prompts/LLMPromptsScene"),
  AIObservabilityPrompt: () =>
    import("../../products/ai_observability/frontend/prompts/LLMPromptScene"),
  AIObservabilityClusters: () =>
    import("../../products/ai_observability/frontend/clusters/AIObservabilityClustersScene"),
  AIObservabilityCluster: () =>
    import("../../products/ai_observability/frontend/clusters/AIObservabilityClusterScene"),
  Alerts: () => import("../../products/alerts/frontend/AlertsScene"),
  PrecomputeDebug: () => import("../../products/analytics_platform/frontend/PrecomputeDebugScene"),
  Annotations: () => import("../../products/annotations/frontend/pages/Annotations"),
  Autoresearch: () => import("../../products/autoresearch/frontend/AutoresearchScene"),
  AutoresearchNew: () => import("../../products/autoresearch/frontend/AutoresearchNewScene"),
  AutoresearchPipeline: () =>
    import("../../products/autoresearch/frontend/AutoresearchPipelineScene"),
  BusinessKnowledge: () =>
    import("../../products/business_knowledge/frontend/scenes/sources/BusinessKnowledgeScene"),
  BusinessKnowledgePlayground: () =>
    import("products/business_knowledge/frontend/scenes/playground/BusinessKnowledgePlaygroundScene"),
  BusinessKnowledgeSettings: () =>
    import("../../products/business_knowledge/frontend/scenes/settings/BusinessKnowledgeSettingsScene"),
  BusinessKnowledgeSource: () =>
    import("../../products/business_knowledge/frontend/scenes/source/KnowledgeSourceScene"),
  CanvasNew: () => import("../../products/canvas/frontend/newCanvas/CanvasNewScene"),
  CanvasDetail: () => import("../../products/canvas/frontend/scene/CanvasScene"),
  Transformations: () => import("../../frontend/src/scenes/data-pipelines/TransformationsScene"),
  EventFiltering: () =>
    import("../../frontend/src/scenes/data-pipelines/event-filtering/EventFilterScene"),
  CohortsStaffTools: () => import("../../products/cohorts/frontend/staff/CohortsStaffToolsScene"),
  SupportTickets: () =>
    import("../../products/conversations/frontend/scenes/tickets/SupportTicketsScene"),
  SupportTicketDetail: () =>
    import("../../products/conversations/frontend/scenes/ticket/SupportTicketScene"),
  SupportSettings: () =>
    import("../../products/conversations/frontend/scenes/settings/SupportSettingsScene"),
  MyTickets: () => import("../../products/conversations/frontend/scenes/myTickets/MyTicketsScene"),
  CustomerAnalytics: () =>
    import("../../products/customer_analytics/frontend/CustomerAnalyticsScene"),
  CustomerAnalyticsAccount: () =>
    import("../../products/customer_analytics/frontend/scenes/CustomerAnalyticsAccountScene/CustomerAnalyticsAccountScene"),
  CustomerAnalyticsConfiguration: () =>
    import("../../products/customer_analytics/frontend/scenes/CustomerAnalyticsConfigurationScene/CustomerAnalyticsConfigurationScene"),
  CustomerJourneyBuilder: () =>
    import("../../products/customer_analytics/frontend/scenes/CustomerJourneyBuilderScene/CustomerJourneyBuilderScene"),
  CustomerJourneyTemplates: () =>
    import("../../products/customer_analytics/frontend/scenes/CustomerJourneyTemplatesScene/CustomerJourneyTemplatesScene"),
  WarehouseProperties: () =>
    import("../../products/customer_analytics/frontend/scenes/WarehousePropertiesScene/WarehousePropertiesScene"),
  DataCatalog: () => import("../../products/data_catalog/frontend/DataCatalogScene"),
  DataCatalogMetric: () => import("../../products/data_catalog/frontend/DataCatalogMetricScene"),
  Models: () => import("../../products/data_modeling/frontend/ModelsScene"),
  NodeDetail: () => import("../../products/data_modeling/frontend/nodeDetail/NodeDetailScene"),
  DataOps: () =>
    import("../../products/data_warehouse/frontend/scenes/DataOpsScene/DataWarehouseScene"),
  Sources: () => import("../../products/data_warehouse/frontend/scenes/SourcesScene/SourcesScene"),
  DataWarehouseSource: () =>
    import("../../products/data_warehouse/frontend/scenes/SourceScene/SourceScene"),
  DataWarehouseSourceNew: () =>
    import("../../products/data_warehouse/frontend/scenes/NewSourceScene/NewSourceScene"),
  DataWarehouseSourceConnect: () =>
    import("../../products/data_warehouse/frontend/scenes/SourceConnectScene/SourceConnectScene"),
  DataWarehouseSourceSchema: () =>
    import("../../products/data_warehouse/frontend/scenes/SchemaScene/SchemaScene"),
  WarehouseDestinations: () =>
    import("../../products/data_warehouse/frontend/scenes/WarehouseDestinationsScene/WarehouseDestinationsScene"),
  EarlyAccessFeatures: () =>
    import("../../products/early_access_features/frontend/EarlyAccessFeatures"),
  EarlyAccessFeature: () =>
    import("../../products/early_access_features/frontend/EarlyAccessFeature"),
  EndpointsScene: () => import("../../products/endpoints/frontend/EndpointsScene"),
  EndpointScene: () => import("../../products/endpoints/frontend/EndpointScene"),
  EngineeringAnalytics: () =>
    import("../../products/engineering_analytics/frontend/scenes/EngineeringAnalyticsScene"),
  EngineeringAnalyticsPullRequest: () =>
    import("../../products/engineering_analytics/frontend/scenes/PullRequestDetailScene"),
  EngineeringAnalyticsWorkflowRun: () =>
    import("../../products/engineering_analytics/frontend/scenes/WorkflowRunDetailScene"),
  EngineeringAnalyticsWorkflowRuns: () =>
    import("../../products/engineering_analytics/frontend/scenes/WorkflowRunsScene"),
  EngineeringAnalyticsAuthor: () =>
    import("../../products/engineering_analytics/frontend/scenes/EngineeringAnalyticsAuthorScene"),
  EngineeringAnalyticsTeam: () =>
    import("../../products/engineering_analytics/frontend/scenes/EngineeringAnalyticsTeamScene"),
  ErrorTracking: () =>
    import("../../products/error_tracking/frontend/scenes/ErrorTrackingScene/ErrorTrackingScene"),
  ErrorTrackingIssue: () =>
    import("../../products/error_tracking/frontend/scenes/ErrorTrackingIssueScene/ErrorTrackingIssueScene"),
  ErrorTrackingFingerprint: () =>
    import("../../products/error_tracking/frontend/scenes/ErrorTrackingFingerprintScene/ErrorTrackingFingerprintScene"),
  Experiments: () => import("../../products/experiments/frontend/scenes/ExperimentsScene"),
  ExperimentsStaffTools: () =>
    import("../../products/experiments/frontend/scenes/ExperimentsStaffToolsScene"),
  FeatureFlagTemplates: () =>
    import("../../products/feature_flags/frontend/FeatureFlagTemplatesScene"),
  FeatureFlagsStaffTools: () =>
    import("../../products/feature_flags/frontend/staff/FeatureFlagsStaffToolsScene"),
  Game368Hedgehogs: () => import("../../products/games/368Hedgehogs/368Hedgehogs"),
  FlappyHog: () => import("../../products/games/FlappyHog/FlappyHog"),
  ShipIt: () => import("../../products/games/frontend/ShipIt/ShipIt"),
  Group: () => import("../../products/groups/frontend/pages/Group"),
  Groups: () => import("../../products/groups/frontend/pages/Groups"),
  GroupsNew: () => import("../../products/groups/frontend/pages/GroupsNew"),
  IdentityMatching: () => import("../../products/growth/frontend/IdentityMatchingScene"),
  AIEnrichment: () => import("../../products/growth/frontend/aiEnrichment/AIEnrichmentScene"),
  LegalDocuments: () =>
    import("../../products/legal_documents/frontend/scenes/LegalDocumentsScene"),
  LegalDocumentNew: () =>
    import("../../products/legal_documents/frontend/scenes/LegalDocumentNewScene"),
  Links: () => import("../../products/links/frontend/LinksScene"),
  Link: () => import("../../products/links/frontend/LinkScene"),
  LiveDebugger: () => import("../../products/live_debugger/frontend/LiveDebugger"),
  Logs: () => import("../../products/logs/frontend/LogsScene"),
  LogsAlertDetail: () =>
    import("../../products/logs/frontend/scenes/LogsAlertDetailScene/LogsAlertDetailScene"),
  LogsAlertNotificationDetail: () =>
    import("../../products/logs/frontend/scenes/LogsAlertNotificationDetailScene/LogsAlertNotificationDetailScene"),
  LogsSamplingNew: () =>
    import("../../products/logs/frontend/scenes/LogsSamplingNewScene/LogsSamplingNewScene"),
  LogsSamplingDetail: () =>
    import("../../products/logs/frontend/scenes/LogsSamplingDetailScene/LogsSamplingDetailScene"),
  LogsRetentionNew: () =>
    import("../../products/logs/frontend/scenes/LogsRetentionNewScene/LogsRetentionNewScene"),
  LogsRetentionDetail: () =>
    import("../../products/logs/frontend/scenes/LogsRetentionDetailScene/LogsRetentionDetailScene"),
  ManagedMigration: () => import("../../products/managed_migrations/frontend/ManagedMigration"),
  ManagedMigrationNew: () => import("../../products/managed_migrations/frontend/ManagedMigration"),
  MCPAnalytics: () => import("../../products/mcp_analytics/frontend/MCPAnalyticsScene"),
  MCPAnalyticsToolDetail: () =>
    import("../../products/mcp_analytics/frontend/MCPAnalyticsToolDetail"),
  MCPRegistry: () => import("../../products/mcp_registry/frontend/MCPRegistryScene"),
  McpGateway: () => import("../../products/mcp_store/frontend/gateway/McpGatewayScene"),
  McpGatewayServer: () => import("../../products/mcp_store/frontend/gateway/GatewayServerScene"),
  McpGatewayAgent: () => import("../../products/mcp_store/frontend/gateway/GatewayAgentScene"),
  McpGatewayMember: () => import("../../products/mcp_store/frontend/gateway/GatewayMemberScene"),
  Metrics: () => import("../../products/metrics/frontend/MetricsScene"),
  DecisionPlayground: () => import("../../products/ml_inference/frontend/DecisionPlaygroundScene"),
  ReusableWidget: () =>
    import("../../products/notebooks/frontend/ReusableWidget/ReusableWidgetScene"),
  Person: () => import("../../products/persons/frontend/pages/PersonScene"),
  Persons: () => import("../../products/persons/frontend/pages/PersonsScene"),
  TaskTracker: () => import("../../products/posthog_ai/frontend/scenes/TaskTracker/TaskTracker"),
  Pulse: () => import("../../products/pulse/frontend/PulseScene"),
  ReplayVision: () =>
    import("../../products/replay_vision/frontend/replay_scanners/ReplayScannersScene"),
  ReplayVisionScanner: () =>
    import("../../products/replay_vision/frontend/replay_scanners/ReplayScanner"),
  ReplayVisionScannerEditor: () =>
    import("../../products/replay_vision/frontend/replay_scanners/ScannerEditorScene"),
  ReplayVisionObservation: () =>
    import("../../products/replay_vision/frontend/observations/ReplayObservation"),
  CodeReview: () => import("../../products/review_hog/frontend/CodeReviewScene"),
  Inbox: () => import("../../products/signals/frontend/inbox/InboxScene"),
  Skills: () => import("../../products/skills/frontend/LLMSkillsScene"),
  Skill: () => import("../../products/skills/frontend/LLMSkillScene"),
  CommunitySkills: () => import("../../products/skills/frontend/CommunitySkillsScene"),
  Stamphog: () => import("../../products/stamphog/frontend/scenes/StamphogScene/StamphogScene"),
  StamphogRuns: () =>
    import("../../products/stamphog/frontend/scenes/StamphogRunsScene/StamphogRunsScene"),
  StamphogDigests: () =>
    import("../../products/stamphog/frontend/scenes/StamphogDigestsScene/StamphogDigestsScene"),
  StreamlitApps: () => import("../../products/streamlit_apps/frontend/StreamlitApps"),
  StreamlitApp: () => import("../../products/streamlit_apps/frontend/StreamlitApp"),
  StreamlitAppEdit: () => import("../../products/streamlit_apps/frontend/StreamlitAppEdit"),
  Subscriptions: () => import("../../products/subscriptions/frontend/scenes/SubscriptionsScene"),
  Subscription: () => import("../../products/subscriptions/frontend/scenes/SubscriptionScene"),
  SlackTaskContext: () => import("../../products/tasks/frontend/SlackTaskContextScene"),
  TaskSpaces: () => import("../../products/tasks/frontend/spaces/SpacesScene"),
  TaskNewSession: () => import("../../products/tasks/frontend/spaces/NewSessionScene"),
  TaskSpace: () => import("../../products/tasks/frontend/spaces/SpaceScene"),
  Tracing: () => import("../../products/tracing/frontend/TracingScene"),
  TracingOperation: () => import("../../products/tracing/frontend/TracingOperationScene"),
  TracingRetentionNew: () =>
    import("../../products/tracing/frontend/scenes/TracingRetentionNewScene/TracingRetentionNewScene"),
  TracingRetentionDetail: () =>
    import("../../products/tracing/frontend/scenes/TracingRetentionDetailScene/TracingRetentionDetailScene"),
  UserInterviews: () => import("../../products/user_interviews/frontend/UserInterviews"),
  UserInterview: () => import("../../products/user_interviews/frontend/UserInterview"),
  UserInterviewResponse: () =>
    import("../../products/user_interviews/frontend/UserInterviewResponse"),
  VisualReviewIndex: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewIndexScene"),
  VisualReviewRuns: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewRunsScene"),
  VisualReviewRun: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewRunScene"),
  VisualReviewSettings: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewSettingsScene"),
  VisualReviewSnapshotHistory: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewSnapshotHistoryScene"),
  VisualReviewSnapshotOverview: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewSnapshotOverviewScene"),
  VisualReviewFlakiness: () =>
    import("../../products/visual_review/frontend/scenes/VisualReviewFlakinessScene"),
  PipelineOverview: () =>
    import("../../products/warehouse_sources/frontend/scenes/PipelineOverviewScene/PipelineOverviewScene"),
  Heatmaps: () =>
    import("../../products/web_analytics/frontend/heatmaps/scenes/heatmaps/HeatmapsScene"),
  Heatmap: () =>
    import("../../products/web_analytics/frontend/heatmaps/scenes/heatmap/HeatmapScene"),
  HeatmapNew: () =>
    import("../../products/web_analytics/frontend/heatmaps/scenes/heatmap/HeatmapNewScene"),
  HeatmapRecording: () =>
    import("../../products/web_analytics/frontend/heatmaps/scenes/heatmap/HeatmapRecordingScene"),
  WizardRuns: () => import("../../products/wizard/frontend/WizardRunsScene"),
  Workflows: () => import("../../products/workflows/frontend/WorkflowsScene"),
  Workflow: () => import("../../products/workflows/frontend/Workflows/WorkflowScene"),
  WorkflowsLibraryTemplate: () =>
    import("../../products/workflows/frontend/TemplateLibrary/MessageTemplate"),
  Broadcasts: () => import("../../products/workflows/frontend/Broadcasts/BroadcastsScene"),
  Broadcast: () => import("../../products/workflows/frontend/Broadcasts/BroadcastScene"),
};
